import React from "react";
import { useTranslation } from "react-i18next";
import {
    ButtonBase,
    ButtonIconTrash,
    InputAutoresize,
    InputFile,
    InputRadio,
    InputSelect,
} from "../../../common/components/form";
import { CurrencyDefault, CurrencyList } from "../../../common/constant/currencies";
import InputMenuLinkTitle from "./InputMenuLinkTitle.jsx";
// import BackNext from "./BackNext.jsx";

// import WizardCheck from "./WizardCheck";
// const { MultipleCheck } = WizardCheck;

const OFFERS_MAX = null;

export default function WStep7Offers(props) {
    const { t } = useTranslation();

    const { set, isCustom, variables, variables2block } = props;

    const items = isCustom ? [variables2block] : [{ variables }];

    return (
        <div className="wizard-part-inner">
            <div style={{ flex: 1 }}>
                <h1>{t("WizardWStep7Header")}</h1>

                {items.map((item, index) => (
                    <Item key={index} {...item} set={(...args) => set(...args, item)} />
                ))}
            </div>
        </div>
    );
}

function Item(props) {
    const { t } = useTranslation();

    const PaymentTypeList = [
        { value: "subscribe", text: t("Subscription") },
        { value: "purchase", text: t("OneTimePurchase") },
    ];

    const {
        next: originNext,
        set,
        variables: { BusinessGoal, PaymentType, Offers },
    } = props;

    const PaymentTypeDefault = PaymentType ?? PaymentTypeList[0].value;

    const _Offers = Offers ?? [{ currency: CurrencyDefault }];

    function next() {
        !PaymentType && set({ PaymentType: PaymentTypeDefault });
        originNext();
    }

    function onPaymentTypeChange(value) {
        set({ PaymentType: value });
    }

    function onItemChange({ name, value }, item) {
        for (const _item of _Offers) {
            if (_item === item) {
                _item[name] = value;
                break;
            }
        }

        set({ Offers: _Offers, PaymentType: PaymentType || PaymentTypeDefault });
    }

    function onPictureSelect(file, item) {
        for (const _item of _Offers) {
            if (_item === item) {
                //TODO! Detect sizes!
                _item.picture = { file, sizes: ["888x556", "1776x1112"] };
                break;
            }
        }

        set({ Offers: _Offers, PaymentType: PaymentType || PaymentTypeDefault });
    }

    function onItemRemove(item) {
        set({ Offers: _Offers.filter(a => a !== item) });
    }

    function onAddItemClick() {
        _Offers.push({ currency: CurrencyDefault });
        set({ Offers: _Offers });
    }

    // const allowNext = MultipleCheck({ PaymentType, Offers });
    return (
        <>
            <div className="margin-top-40">
                <InputMenuLinkTitle name="Offers" {...props} />
            </div>

            {BusinessGoal === "selling-plans" && (
                <div className="flex-center flex-gap-40 margin-top-40">
                    {PaymentTypeList.map(({ value, text }) => (
                        <div key={value}>
                            <InputRadio
                                onChange={() => onPaymentTypeChange(value)}
                                checked={(PaymentType ?? PaymentTypeDefault) === value}
                            >
                                <span>{text}</span>
                            </InputRadio>
                        </div>
                    ))}
                </div>
            )}

            <div className="margin-top-40 grid-gap-40 grid-center">
                {_Offers.map((offer, index) => (
                    <div key={index} className="flex-gap-20 flex-center relative">
                        <div className="grid-gap-20 wizard-offers" style={{ width: "320px" }}>
                            {BusinessGoal === "traffic-acquisition" && (
                                <p>{t("WizardWStep7OfferTrafficAcquisitionText")}</p>
                            )}

                            <OfferTitle BusinessGoal={BusinessGoal} offer={offer} onItemChange={onItemChange} />

                            {BusinessGoal === "selling-plans" && (
                                <>
                                    <OfferCostCurrency offer={offer} onItemChange={onItemChange} />
                                    <OfferButtonTextLink offer={offer} onItemChange={onItemChange} />
                                    <OfferDescription offer={offer} onItemChange={onItemChange} />
                                    <OfferFeatures offer={offer} onItemChange={onItemChange} />
                                </>
                            )}

                            {BusinessGoal === "traffic-acquisition" && (
                                <>
                                    <p>{t("WizardWStep7OfferTrafficAcquisitionPictureText")}</p>
                                    <InputFile
                                        read
                                        filename={offer?.picture?.file?.name}
                                        placeholder={t("PlusAdd")}
                                        onFileSelect={file => onPictureSelect(file, offer)}
                                    />
                                    <OfferDescription offer={offer} onItemChange={onItemChange} />
                                    <OfferButtonTextLink offer={offer} onItemChange={onItemChange} />
                                </>
                            )}

                            <OfferDelete offer={offer} offerList={_Offers} onItemRemove={onItemRemove} />
                        </div>
                    </div>
                ))}

                <div>
                    <ButtonBase dashed onClick={onAddItemClick} disabled={OFFERS_MAX && _Offers.length >= OFFERS_MAX}>
                        {t("PlusAdd")}
                    </ButtonBase>
                </div>
            </div>
        </>
    );
}

function OfferTitle(props) {
    const { i18n, t } = useTranslation();
    const { BusinessGoal, offer, onItemChange } = props;

    // business-goals.js value
    const placeholder_t = {
        "selling-plans": "WizardWStep7OfferTitleInputPlaceholderSellingPlans",
        "traffic-acquisition": "WizardWStep7OfferTitleInputPlaceholderTrafficAcquisition",
    }[BusinessGoal];

    return (
        <InputAutoresize
            className="full-width"
            name="title"
            onChange={({ target: { name, value } }) => onItemChange({ name, value }, offer)}
            value={offer.title || ""}
            placeholder={t(placeholder_t)}
        />
    );
}

function OfferCostCurrency(props) {
    const { i18n, t } = useTranslation();
    const { offer, onItemChange } = props;
    const CurrencyOptionList = CurrencyList.map(currency => ({ value: currency, text: currency.toUpperCase() }));
    return (
        <>
            <div className="grid-gap-20" style={{ gridTemplateColumns: "2fr 1fr" }}>
                <InputAutoresize
                    className="full-width"
                    name="cost"
                    onChange={({ target: { name, value } }) => onItemChange({ name, value }, offer)}
                    value={offer.cost || ""}
                    placeholder={t("WizardWStep7OfferCostInputPlaceholder")}
                />

                <div>
                    <InputSelect
                        fullWidth
                        name="currency"
                        onSelect={value => onItemChange({ name: "currency", value }, offer)}
                        selected={offer.currency || ""}
                        options={CurrencyOptionList}
                        placeholder={t("WizardWStep7OfferCurrencyInputPlaceholder")}
                    />
                </div>
            </div>
        </>
    );
}

function OfferButtonTextLink(props) {
    const { i18n, t } = useTranslation();
    const { offer, onItemChange } = props;
    return (
        <>
            <InputAutoresize
                className="full-width"
                name="button"
                onChange={({ target: { name, value } }) => onItemChange({ name, value }, offer)}
                value={offer.button || ""}
                placeholder={t("WizardWStep7OfferButtonTextInputPlaceholder")}
            />

            <InputAutoresize
                className="full-width"
                name="buttonLink"
                onChange={({ target: { name, value } }) => onItemChange({ name, value }, offer)}
                value={offer.buttonLink || ""}
                placeholder={t("WizardWStep7OfferButtonLinkInputPlaceholder")}
            />
        </>
    );
}

function OfferDescription(props) {
    const { i18n, t } = useTranslation();
    const { offer, onItemChange } = props;
    return (
        <InputAutoresize
            className="full-width"
            name="description"
            onChange={({ target: { name, value } }) => onItemChange({ name, value }, offer)}
            value={offer.description || ""}
            placeholder={t("WizardWStep7OfferDescriptionInputPlaceholder")}
            rows="3"
        />
    );
}

function OfferFeatures(props) {
    const { i18n, t } = useTranslation();
    const { offer, onItemChange } = props;
    return (
        <InputAutoresize
            className="full-width"
            name="features"
            onChange={({ target: { name, value } }) => onItemChange({ name, value }, offer)}
            value={offer.features || ""}
            placeholder={t("WizardWStep7OfferFeaturesInputPlaceholder")}
            rows="3"
            multirow
        />
    );
}

function OfferDelete(props) {
    const { offer, offerList, onItemRemove } = props;

    return (
        <div className="absolute" style={{ left: "calc(100% + 20px)" }}>
            <ButtonIconTrash noMargin disabled={offerList.length < 2} onClick={() => onItemRemove(offer)} />
        </div>
    );
}
